// extracted by mini-css-extract-plugin
export default {"formContainer":"CurrentMarketStructure_formContainer__LsKUW","selectContainer":"CurrentMarketStructure_selectContainer__SL+5g"};